import axios from '@/requests';
import { SkypeConv, SkypeMsgGroup } from '@/store/modules/skype/types';

export interface GetSkypeUsersReq {
    projId: string,
    uid: string,
}

export interface GetSkypeConvsReq {
    projId: string,
    uid: string,
    userName: string,
    limit: number,
    page: number,
}

export interface GetSkypeMsgReq {
    projId: string,
    uid: string,
    userName: string
    id: string,
    limit: number,
    page: number,
}

export const skypeAPI = {
    async getSkypeUsers(getSkypeUsersReq: GetSkypeUsersReq): Promise<string[]> {
        try {
            const res = await axios.get<string[]>('/Skype/getSkypeUserListByProjIdAndUid', getSkypeUsersReq);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async getSkypeConvs(getSkypeConvsReq: GetSkypeConvsReq): Promise<SkypeConv[]> {
        try {
            // TODO
            // Maybe construction on empty array should be done in backend.
            const res = await axios.get<SkypeConv[] | null>('/Skype/getSkypeConvListByUid', getSkypeConvsReq);
            if (res) {
                return res;
            } else {
                return [];
            }
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getSkypeMsgByConvId(getSkypeMsgReq: GetSkypeMsgReq): Promise<SkypeMsgGroup | null> {
        try {
            const res = await axios.get<SkypeMsgGroup>('Skype/getMessageListByConvId', getSkypeMsgReq);

            // Hacking solution to return value empty.
            // Should be solved in backend.
            if (!res.msgs) {
                return {
                    isGroup: false,
                    msgs: [],
                };
            }
            if (res) {
                return res;
            } else {
                return {
                    isGroup: false,
                    msgs: [],
                };
            }
        } catch (err) {
            return Promise.reject(err);
        }
    }
}

